import { render } from "./AddressField.vue?vue&type=template&id=86a2d4a4"
import script from "./AddressField.vue?vue&type=script&lang=js"
export * from "./AddressField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__